import { ThunkAction } from 'redux-thunk';
import * as Bixby from '../../core';
import { AppState } from '..';
import {
  ALL_CLO_DEAL_MANAGER_SUCCESS,
  ADD_CLIENT_CLO_DEAL_MANAGER,
  ADD_CLIENT_CLO_DEAL_MANAGER_SUCCESS,
  ADD_CLIENT_CLO_DEAL_MANAGER_FAILURE,
  DELETE_CLIENT_CLO_DEAL_MANAGER,
  DELETE_CLIENT_CLO_DEAL_MANAGER_SUCCESS,
  DELETE_CLIENT_CLO_DEAL_MANAGER_FAILURE,
  ALL_CLO_DEAL_MANAGER_FAILURE,
  ALL_CLO_DEAL_MANAGER_LOADING,
} from './types';
import { CloDealService } from '$/services';
import { toastError, toastSuccess } from '../toast/actions';


export const allCloDealManagerLoadAction = () => {
  return {
    type: ALL_CLO_DEAL_MANAGER_LOADING,
  };
};

export const allCloDealManagerSuccessAction = (payload: Bixby.Models.CloDealManager[]) => {
  return {
    type: ALL_CLO_DEAL_MANAGER_SUCCESS,
    payload,
  };
};

export const allCloDealManagerFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: ALL_CLO_DEAL_MANAGER_FAILURE,
    payload: error,
    addError: true,
  };
};

const addClientCloDealManagerAction = () => {
  return {
    type: ADD_CLIENT_CLO_DEAL_MANAGER,
  };
};

const addClientCloDealManagerFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: ADD_CLIENT_CLO_DEAL_MANAGER_FAILURE,
    payload: error,
    addError: true,
  };
};

const addClientCloDealManagerSuccessAction = () => {
  return {
    type: ADD_CLIENT_CLO_DEAL_MANAGER_SUCCESS,
  };
};

const deleteClientCloDealManagerAction = () => {
  return {
    type: DELETE_CLIENT_CLO_DEAL_MANAGER,
  };
};

const deleteClientCloDealManagerSuccessAction = () => {
  return {
    type: DELETE_CLIENT_CLO_DEAL_MANAGER_SUCCESS,
  };
};

const deleteClientCloDealManagerFailureAction = (error: Bixby.Models.BixbyError) => {
  return {
    type: DELETE_CLIENT_CLO_DEAL_MANAGER_FAILURE,
    payload: error,
    deleteError: true,
  };
};

export const getAllCloDealManagers =
  (): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => async dispatch => {
    dispatch(allCloDealManagerLoadAction());
    try {
      const cloDealManagers = await CloDealService.getAllCloDealManagers();
      dispatch(allCloDealManagerSuccessAction(cloDealManagers));
    } catch (error: any) {
      dispatch(allCloDealManagerFailureAction(error));
    }
  };

export const addClientCloDealManager = (
  clientId: string,
  managerId: string,
  onAddSuccess: () => void
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => 
  async dispatch => {
  dispatch(addClientCloDealManagerAction());
  try {
    await CloDealService.addClientCloDealManager(clientId, managerId);
    dispatch(addClientCloDealManagerSuccessAction());
    onAddSuccess();
    await dispatch(toastSuccess(`Added successfully`));
  } catch (error : any) {
    dispatch(addClientCloDealManagerFailureAction(error));
    await dispatch(toastError(`CLO manager could not be added`));
  }
};

export const deleteClientCloDealManager = (
  clientId: string,
  managerId: string,
  onDeleteSuccess: () => void
): ThunkAction<Promise<void>, AppState, null, Bixby.Models.BixbyAction> => 
  async dispatch => {
  dispatch(deleteClientCloDealManagerAction());
  try {
    await CloDealService.deleteClientCloDealManager(clientId, managerId);
    await dispatch(deleteClientCloDealManagerSuccessAction());
    onDeleteSuccess();
    await dispatch(toastSuccess(`Manager deleted successfully`));
  } catch (error : any) {
    dispatch(deleteClientCloDealManagerFailureAction(error));
    await dispatch(toastError(`CLO manager could not be deleted`));
  }
};
